export default function KIYGIntro() {
  return (
    <div style={{ padding: "20px", textAlign: "left" }}>
      <h1 className="text-center">Khelo India Youth Games 2025 Bihar</h1>
      {/* <h3>About KIYG 2025</h3> */}
      <p>
        <br/>
        Khelo India is a flagship program launched by the Government of India,
        aimed at identifying sporting talent in the country, promoting sports at
        the grassroots level and developing sports infrastructure. This
        initiative is an important step towards strengthening the sports culture
        in India.
      </p>
      <br />
      <p>
        For the first time, Khelo India Youth Games were held in Delhi in 2018.
        Subsequently,
      </p>
      <br />
      <ul style={{ paddingLeft: "20px" }}>
        <li style={{ listStyleType: "disc" }}>Pune, Maharashtra in 2019,</li>
        <li style={{ listStyleType: "disc" }}>Guwahati, Assam in 2020,</li>
        <li style={{ listStyleType: "disc" }}>Panchkula, Haryana in 2022,</li>
        <li style={{ listStyleType: "disc" }}>Madhya Pradesh in 2023,</li>
        <li style={{ listStyleType: "disc" }}>2024 – Tamil Nadu</li>
      </ul>
      <br />
      <p>
        Now, Khelo India 2025 is going to be organized in Bihar. This
        prestigious sports competition will be from 4 May to 15 May 2025, in
        which young players from all over the country will showcase their
        talent. This event will play an important role in increasing awareness
        about sports in Bihar and giving a new dimension to the sports culture.
      </p>
    </div>
  );
}
